/** @format */

import { useNavigate } from "react-router-dom";
import ICBack from "@/assets/common/ic_back_mobile.svg?react";
import { useState } from "react";
import MobileChoosePop from "@/component/MobileChoosePop";
import Dialog from "@/component/Dialog";

export interface ITitleHeaderProps {
  title: string;
  bgColor?: string;
  backPop?: IBackPopProps;
  popupType?: 'popup' | 'dialog'; // 修改为更通用的命名
  buttonOrder?: 'default' | 'reverse'; // 新增按钮顺序配置
}

export interface IBackPopProps {
  popTitle?: string;
  confirmText?: string;
  cancelText?: string;
}

const TitleHeader: React.FC<ITitleHeaderProps & IBackPopProps> = ({
  title,
  bgColor = "#CCDCFD",
  backPop = null,
  popupType = 'popup', // 默认使用popup样式
  buttonOrder = 'default',
}) => {
  const navigate = useNavigate();
  const [showBackPop, setShowBackPop] = useState(false);

  const back = () => {
    if (backPop) {
      setShowBackPop(true);
    } else {
      navigate("/home", { replace: true });
    }
  };

  const handleConfirm = () => {
    setShowBackPop(false);
    navigate("/home", { replace: true });
  };

  const handleCancel = () => {
    setShowBackPop(false);
  };

  // 渲染弹窗
  const renderPopup = () => {
    if (!showBackPop || !backPop) return null;

    if (popupType === 'dialog') {
      return (
        <Dialog
          isOpen={showBackPop}
          title={backPop.popTitle || "提示"}
          content=""
          onCancel={buttonOrder === 'default' ? handleCancel : handleConfirm}
          onConfirm={buttonOrder === 'default' ? handleConfirm : handleCancel}
          cancelText={buttonOrder === 'default' ? backPop.cancelText || "取消" : backPop.confirmText || "确定"}
          confirmText={buttonOrder === 'default' ? backPop.confirmText || "确定" : backPop.cancelText || "取消"}
          confirmType="primary"
        />
      );
    }

    // 默认使用popup样式（MobileChoosePop）
    return (
      <div className="fixed inset-0 z-50">
        <MobileChoosePop
          visible={showBackPop}
          title={backPop.popTitle || ""}
          options={[
            {
              label: backPop.confirmText || "确定",
              action: handleConfirm,
            },
            {
              label: backPop.cancelText || "取消",
              action: handleCancel,
            },
          ]}
        />
      </div>
    );
  };

  return (
    <>
      <div
        className={`px-3 h-14 flex items-center justify-between bg-${bgColor}`}
      >
        <div className="flex items-center flex-1 min-w-0">
          <ICBack
            className="w-6 h-6 cursor-pointer flex-shrink-0"
            onClick={back}
          />
          <div className="flex-1 min-w-0">
            <div className="text-4 color-#333 font-500 lh-6 truncate max-w-full">
              {title}
            </div>
          </div>
        </div>
      </div>
      {renderPopup()}
    </>
  );
};

export default TitleHeader;
